import { render } from "./BaseFieldPhone.vue?vue&type=template&id=1451de45"
import script from "./BaseFieldPhone.vue?vue&type=script&lang=js"
export * from "./BaseFieldPhone.vue?vue&type=script&lang=js"

import exportComponent from "/builds/rclass/new_shlepakov/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__